// Entra config is injected at build time by rollup. The SECURESHARE_*
// placeholders get string-replaced during the bundle step — empty
// strings when the build is running in mock-oidc mode, real values
// when running in entra mode via local/docker-compose.entra.yml.
//
// Fallback tenant/client: when the build variables aren't set (e.g.
// local dev bundling without passing them in), we fall back to the
// CareEvolution prod app registration so anyone who opens the SPA
// outside localhost still gets the same behavior we always had.
const INJECTED_CLIENT_ID = "SECURESHARE_AZURE_CLIENT_ID";
const INJECTED_TENANT_ID = "SECURESHARE_AZURE_TENANT_ID";
const INJECTED_API_SCOPE = "SECURESHARE_AZURE_API_SCOPE";

const FALLBACK_CLIENT_ID = "3e78d69c-9686-4fdb-ac41-2c79ed3ac3fa";
const FALLBACK_TENANT_ID = "4cba62ed-2c05-4c48-9e6b-1c51ea174880";
const FALLBACK_API_SCOPE = "api://3e78d69c-9686-4fdb-ac41-2c79ed3ac3fa/SecureShareAccess";

const clientId = INJECTED_CLIENT_ID || FALLBACK_CLIENT_ID;
const tenantId = INJECTED_TENANT_ID || FALLBACK_TENANT_ID;
const apiScope = INJECTED_API_SCOPE || FALLBACK_API_SCOPE;

const msalConfig = {
    auth: {
      clientId: clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
  };

  // Login request: OIDC scopes so loginPopup returns a proper ID
  // token and account object. Keeping the custom API scope OUT of
  // this request — if a custom scope is in loginPopup's scope list,
  // MSAL may not return a usable access token for it (the access
  // token field ends up empty or undefined, and downstream requests
  // send "Bearer undefined" which Flask rejects with "Not enough
  // segments"). Use `tokenRequest` + acquireTokenSilent for the
  // actual API access token instead.
  const loginRequest = {
   scopes: ["openid", "profile"]
  };

  // Token request: the custom API scope. Sent via
  // `acquireTokenSilent(tokenRequest)` AFTER login completes, so the
  // returned token has `aud = clientId` and Flask's auth.py accepts
  // it. Without this split the access token ends up Graph-audience
  // or empty.
  const tokenRequest = {
   scopes: [apiScope]
  };

  export { msalConfig, loginRequest, tokenRequest };